// extracted by mini-css-extract-plugin
export default {"editor":"crop_editor__ht9oF","banner":"crop_banner__4vYiM","cropper":"crop_cropper__IAnyJ","slide-in-bottom":"crop_slide-in-bottom__8YLIL"};